export const layersConfig = [
    {
        title: 'ISO Market Points',
        description:
            'This layer represents pricing nodes in each of the ISOs. Locations are not available for all nodes, so this displays only nodes with coordinates available. Locations match the precision of the underlying source, primarily EIA and ISO publications.',
    },
    {
        title: 'Substations',
        description:
            'This layer represents electric power substations primarily associated with electric power transmission. In this layer, substations are considered facilities and equipment that switch, transform, or regulate electric power at voltages equal to, or greater than, 69 kilovolts. Substations with a maximum operating voltage less than 69 kilovolts may be included, depending on the availability of authoritative sources, but coverage of these features should not be considered complete.',
    },
    {
        title: 'Powerplants',
        description:
            'This layer represents electric power plants. Power plants are all the land and land rights, structures and improvements, boiler or reactor vessel equipment, engines and engine-driven generators, turbo generator units, accessory electric equipment, and miscellaneous power plant equipment are grouped together for each individual facility. Included are the following plant types: hydroelectric dams, fossil fuel (coal, natural gas, or oil), nuclear, solar, wind, geothermal, and biomass.',
    },
    {
        title: 'Interconnection Queue: Planned Generators',
        description:
            "This layer displays the EIA inventory of planned generators. The list does not include every project in each ISO's Interconnection Queue, but it provides a useful subset to identify planned projects.",
    },
    {
        title: 'Interconnection Queue: Retired Generators',
        description:
            "This layer displays the EIA inventory of retired generators since 2002. The list does not include every project in each ISO's Interconnection Queue, but it provides a useful subset to identify retired projects.",
    },
    {
        title: 'Planned Retirements',
        description:
            'This layer displays the generators in the EIA inventory that have planned retirement dates. Shade indicates the retirement date, from dark brown (sooner) to light brown (later).',
    },
    {
        title: 'Transmission Lines',
        description:
            'This layer represents electric power transmission lines. Transmission Lines are the system of structures, wires, insulators and associated hardware that carry electric energy from one point to another in an electric power system. Lines are operated at relatively high voltages varying from 69 kV up to 765 kV, and are capable of transmitting large quantities of electricity over long distances. Underground transmission lines are included where sources were available.',
    },
    {
        title: 'Electric Retail Service Territories',
        description:
            'This layer represents electric power retail service territories. These are areas serviced by electric power utilities responsible for the retail sale of electric power to local customers, whether residential, industrial, or commercial.',
    },
    {
        title: 'Qualified Opportunity Zones',
        description:
            'A QOZ is an economically distressed community where new investments, under certain conditions, may be eligible for preferential tax treatment. QOZs were added to the tax code by the Tax Cuts and Jobs Act on December 22, 2017.',
    },
    {
        title: '2020 Median Home Value',
        description:
            'This layer shows the median home value in the U.S. in 2020 in a multiscale map by country, state, county, ZIP Code, tract, and block group.',
    },
    {
        title: 'Ascend ISO Forecasting Subregions',
        description:
            "This layer shows Ascend's forecasting regions within an ISO, which are based on Ascend's analysis of geospatial boundaries and patterns that affect current and future resource buildout and price formation.",
    },
    {
        title: 'Planned Storage & Solar Projects (Construction)',
        custom_title: 'Construction',
        description:
            'This layer represents electric power transmission lines. Transmission Lines are the system of structures, wires, insulators and associated hardware that carry electric energy from one point to another in an electric power system. Lines are operated at relatively high voltages varying from 69 kV up to 765 kV, and are capable of transmitting large quantities of electricity over long distances. Underground transmission lines are included where sources were available.',
    },
    {
        title: 'Planned Storage & Solar Projects (Contracted)',
        custom_title: 'Contracted',
    },
    {
        title: 'Planned Storage & Solar Projects (Operational)',
        custom_title: 'Operational',
    },
    {
        title: 'Planned Storage & Solar Projects (Pipeline/Proposed)',
        custom_title: 'Pipeline/Proposed',
    },
];
